import React, { useEffect } from "react";
import QuestionInput from "./QuestionInput";
import QuestionTable from "./QuestionTable";
import { GuidanceBlock, TRIP_SEP, SUFFIX_SEP } from "./displayConditionUtils";

const QuestionCard = ({
  isEmployee,
  question,
  displayIndex,
  answers,
  setAnswers,
  handleAnswerChange,
  optionsCache,
  setOptionsCache,
  tripIndex = null,
  optionSuffix = "",
  optionLabel = "",
  onQuestionLoaded,
  divisionId,
}) => {
  let baseId = question.questionId || question.questionID;
  if (tripIndex !== null) baseId += `${TRIP_SEP}${tripIndex}`;

  let fullId = baseId;
  if (optionSuffix) fullId += `${SUFFIX_SEP}${optionSuffix}`;

  // Smart Lookup: Try fullId first, then baseId, then injected value
  let currentValue =
    answers[fullId] !== undefined
      ? answers[fullId]
      : answers[baseId] !== undefined
        ? answers[baseId]
        : question.value || question.answer;

  // Extraction for object-based values
  if (
    currentValue &&
    typeof currentValue === "object" &&
    !Array.isArray(currentValue)
  ) {
    currentValue =
      currentValue.value !== undefined
        ? currentValue.value
        : currentValue.answer !== undefined
          ? currentValue.answer
          : currentValue;
  }

  const id = answers[fullId] !== undefined ? fullId : baseId;

  useEffect(() => {
    if (question && onQuestionLoaded) {
      onQuestionLoaded(question, divisionId);
    }
  }, [question, onQuestionLoaded, divisionId]);

  return (
    <div className="rounded-[10px] border border-[#D9E1E7] bg-white p-4">
      {question.questionTitle &&
        (Array.isArray(question.questionTitle)
          ? question.questionTitle.length > 0
          : true) && (
          <div className="mb-4 pb-2 border-b border-gray-100">
            <p className="text-[14px] font-semibold text-[#06513D] leading-relaxed">
              {Array.isArray(question.questionTitle)
                ? question.questionTitle.join(" ")
                : question.questionTitle}
            </p>
          </div>
        )}
      <GuidanceBlock guidance={question.guidance} />

      <div className="mb-3">
        <div className="text-[15px] font-semibold text-[#1F2937] leading-6">
          {displayIndex}. {question.questionText}
        </div>
      </div>

      {(tripIndex !== null || optionLabel) && (
        <div className="mb-3 flex flex-wrap gap-2">
          {/* Loop/Trip labels can be un-commented if needed for debugging */}
        </div>
      )}

      {question.questionType === "table" ? (
        <QuestionTable
          isEmployee={isEmployee}
          question={question}
          tableId={id}
          answers={answers}
          setAnswers={setAnswers}
          onQuestionLoaded={onQuestionLoaded}
          divisionId={divisionId}
        />
      ) : (
        <QuestionInput
          isEmployee={isEmployee}
          field={question}
          value={currentValue}
          onChange={(val) => handleAnswerChange(id, val)}
          onOptionsLoaded={(qid, opts) => {
            setOptionsCache((prev) => ({ ...prev, [qid]: opts }));
          }}
        />
      )}
    </div>
  );
};

export default QuestionCard;
